import { HttpError } from '@refinedev/core';
import axios from 'axios';

/** The BE answers errors with either `{ message }` or Rails' `custom_error`
 *  shape `{ success: false, error: '<text>' }`. Both must reach the toast;
 *  without the second branch a 422 degrades to axios' internal
 *  "Request failed with status code 422". A 5xx `error` is an exception
 *  message, not user text, so it keeps the generic message. */
export const resolveHttpErrorMessage = (error: any): string => {
  const data = error?.response?.data;
  const status = error?.response?.status;
  if (typeof data?.message === 'string' && data.message) return data.message;
  if (typeof data?.error === 'string' && data.error && status < 500) return data.error;
  return error?.message;
};

const baseAxiosInstance = axios.create({
  timeout: 35000, // 35 seconds
});

baseAxiosInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error) => {
    const customError: HttpError = {
      ...error,
      message: resolveHttpErrorMessage(error),
      statusCode: error.response?.status ?? error?.code,
    };

    return Promise.reject(customError);
  }
);

export { baseAxiosInstance };
